window.jRespond = window.jRespond || require('jRespond');
var Calendar = {};

(function ($) {
    'use strict';

    Calendar = function () {

        var self = {}, __self = {};

        self.init = function () {

            // DOM Elements
            __self.$body = $('body');
            __self.$loadingOverlay = $('.calendar > .js-loading');

            // jRespond Settings
            __self.jRes = jRespond([
            {
                label: 'mobile',
                enter: 0,
                exit: 999
            },{
                label: 'desktop',
                enter: 1000,
                exit: 10000
            }
            ]);

            // jRespond Behavior
            __self.jRes.addFunc([
            {
                breakpoint: ['mobile'],
                enter: function() {
                    __self.breakpoint = 'mobile';
                },
                exit: function() {

                }
            },
            {
                breakpoint: ['desktop'],
                enter: function() {
                    __self.breakpoint = 'desktop';
                },
                exit: function() {
                }
            }
            ]);

            // Module Init
            self.calendarInit();
        };

        self.calendarInit = function () {

            self.modileRedirectCalendar();

        };

        self.modileRedirectCalendar = function() {
            if(CalendarView.is_month === '1' && __self.breakpoint === 'mobile') {
                __self.$loadingOverlay.fadeIn(250); 
                window.location.replace(CalendarView.list_url);
            } else {
                setTimeout(function() {
                    __self.$loadingOverlay.fadeOut(300); 
                }, 250);
            }
        };

        self.resize = function() {
            self.modileRedirectCalendar();
        };

        self.init();
        return self;
    };

}(window.jQuery));

module.exports = Calendar;
